import { Directive, Attribute, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

@Directive({
  selector: '[min][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => JbMinValidator), multi: true }
  ]
})
export class JbMinValidator {
  constructor(@Attribute('min') public min: number) { }

  validate(c: FormControl): { [key: string]: any } {
    return c.value >= this.min ? null : {
      min: {
        valid: false
      }
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/form/validators/min.validator.ts